import React, { FC, useCallback } from 'react';
import { checkSectionWorkLists } from 'shared/helpers/work-list-helpers/move-to-helpers/moving-lists-helper';
import { localized } from 'shared/state/i18n/i18n';
import { TextWeb } from 'web/web-helpers/styled-text-components';
import { FlexColumn } from '../../basic-flex/flex-column';
import SkioldFormPenPicker from '../../location/location-picker/skiold-form-pen-picker';
import SkioldStableSectionPicker from '../../location/location-picker/skiold-stable-section-picker';
import { ViewWeb } from '../../utils/web-view';
import '../list-setup.scss';
import { useBasicMoveList } from './basic-move-list-overview';
import { SkioldDatePicker } from '../../skiold-components/skiold-date-picker/skiold-date-picker';

export const BasicMoveListHeader: FC = React.memo(() => {
	const {
		fromPenId,
		fromSectionId,
		toPenId,
		toSectionId,
		setFromSectionId,
		setFromPenId,
		setToSectionId,
		setToPenId,
		moveDate,
		setMoveDate,
	} = useBasicMoveList();

	const fromSectionCallback = useCallback(
		(id: string) => {
			const { penId, usesPens } = checkSectionWorkLists(id, undefined);
			setFromSectionId(id);
			checkSectionWorkLists;
			if (usesPens) {
				setFromPenId('');
			} else {
				setFromPenId(penId!);
			}
		},
		[setFromSectionId, setFromPenId],
	);

	const toSectionCallback = useCallback(
		(id: string) => {
			const { penId, usesPens } = checkSectionWorkLists(id, undefined);
			setToSectionId(id);
			checkSectionWorkLists;
			if (usesPens) {
				setToPenId('');
			} else {
				setToPenId(penId!);
			}
		},
		[setToSectionId, setToPenId],
	);

	return (
		<FlexColumn className="work-list">
			<ViewWeb className="z-index-1000">
				<ViewWeb className="getrows">
					<ViewWeb className="flex-direction-column">
						{/* <ViewWeb className="buttons-no-right-border">
							<TextWeb className="stable-section-text">{localized('moveDate')}:</TextWeb>
							<SkioldDatePicker selectedDate={moveDate} onDateChanged={setMoveDate} />
						</ViewWeb> */}
						<ViewWeb className="flexFour flex-direction-row ">
							<ViewWeb className="buttons-no-right-border">
								<TextWeb className="stable-section-text">{localized('chooseLocation')}:</TextWeb>
								<SkioldStableSectionPicker
									onStableSectionSelected={fromSectionCallback}
									sectionId={fromSectionId}
									isPigProduction={true}
									containerClassName="picker-width"
								/>
							</ViewWeb>
							<ViewWeb className="pen-picker-container">
								<TextWeb className="pen-text">{localized('Pen')}:</TextWeb>
								<SkioldFormPenPicker
									onPenSelected={setFromPenId}
									sectionId={fromSectionId}
									penId={fromPenId}
									theme="light"
									containerClassName="picker-width"
									usedInsideForm={false}
								/>
							</ViewWeb>
						</ViewWeb>
						<ViewWeb className="flexFour flex-direction-row ">
							<ViewWeb className="buttons-no-right-border">
								<TextWeb className="stable-section-text">{localized('chooseLocation')}:</TextWeb>
								<SkioldStableSectionPicker
									onStableSectionSelected={toSectionCallback}
									sectionId={toSectionId}
									isPigProduction={true}
									containerClassName="picker-width"
								/>
							</ViewWeb>
							<ViewWeb className="pen-picker-container">
								<TextWeb className="pen-text">{localized('Pen')}:</TextWeb>
								<SkioldFormPenPicker
									onPenSelected={setToPenId}
									sectionId={toSectionId}
									penId={toPenId}
									theme="light"
									containerClassName="picker-width"
									usedInsideForm={false}
								/>
							</ViewWeb>
						</ViewWeb>
					</ViewWeb>
				</ViewWeb>
			</ViewWeb>
		</FlexColumn>
	);
});
